import React, { ReactNode } from 'react';
import swish from '../../../assets/swish.svg';
import glow from '../../../assets/glow.svg';
import { SVGBackground, UnBrandedBackground } from '../styling/styled';

export enum BackgroundVariant {
  Swish = 'swish',
  Glow = 'glow',
  None = 'none',
}

export const Background = ({
  backgroundVariant,
  children,
}: {
  backgroundVariant?: BackgroundVariant;
  children: ReactNode;
}) => {
  if (backgroundVariant === BackgroundVariant.Swish)
    return <SVGBackground $src={swish}>{children}</SVGBackground>;
  if (backgroundVariant === BackgroundVariant.Glow)
    return <SVGBackground $src={glow}>{children}</SVGBackground>;
  return <UnBrandedBackground>{children}</UnBrandedBackground>;
};
